/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TriggerAnalysisResponseBody = {
  projectsSignaled: number;
};

/** @internal */
export const TriggerAnalysisResponseBody$inboundSchema: z.ZodMiniType<
  TriggerAnalysisResponseBody,
  unknown
> = z.pipe(
  z.object({
    projects_signaled: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "projects_signaled": "projectsSignaled",
    });
  }),
);

export function triggerAnalysisResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<TriggerAnalysisResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TriggerAnalysisResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TriggerAnalysisResponseBody' from JSON`,
  );
}
